const auth = {
    state: {
        loginAuthForm: {
            phone: '',
            type: '',
            graphicState: '',
            graphicCode: '',
            code: '',
            autographType: ''
        }
    },
    mutations: {
        SETLOGINAUTHFORM(state, data) {
            state.loginAuthForm = {
                ...data
            }
        }
    }
}

export default auth